module.exports = __webpack_public_path__ + "img/sr.2bd0a7a4.jpg";